import $ from 'jquery';
var fileList;
var uploadsLocation;
var allYears = [];
var yearOpen = 0;
var yearClicked = 0;
class Minutes {

    constructor(){
        if ($("#minutes").length ){
            fileList = this.getFileList(this);
            uploadsLocation = dysData.uploads_folder;
            this.events();
        }
    }

    events() {
        //  Register Listeners
        //$("#year-dropdown").on("change", this.yearChanged.bind(this));
        $("#minutes-upload-button").on("click",this.uploadClicked.bind(this));
    }


    //  Methods
    uploadClicked(e){
        $("#minutes-upload-button").addClass('d-none');
        $("#minutes-upload-form").removeClass('d-none');
    }
    getFileList(){  //Get List of results files from Server
        $.ajax({
            beforeSend:(xhr) => {
                xhr.setRequestHeader('X-WP-Nonce',dysData.nonce);
            },
            url: dysData.root_url + '/wp-json/results/v1/minutes/',
            type: 'POST',
            success: (response) => {
                this.breakdownFileList(response);
                
            },
            error: (response) => {
                console.log("Invalid Data Response");
                console.log(response);
            }
        });
    }
    yearClicked(e){
        yearClicked = e.target.id;
        if (yearClicked!=""){                   //  If something other than the year is clicked
            if (yearClicked == yearOpen){
                this.closeYearElements();
                this.yearOpen = 0;
            }
            else{
                this.closeYearElements();
                this.openYearElements();
            }
        }
    }

    breakdownFileList(response){
        fileList = JSON.parse(response);
        this.buildYearsArray(fileList);
    }
    
    buildYearsArray(fileList){
    var currentYear="";
    var fileName;

    for (var i=0; i<fileList.length; i++){
        //  Check REGEX here for '9999-99-99 *'
        fileName = fileList[i].split('-');
        if (currentYear != fileName[0]){
            allYears.push(fileName[0]);
            currentYear = fileName[0];
        }
    }
    allYears.sort();
    allYears.reverse();

    for (i=0;i< allYears.length;i++){
        $("#minutes").append(`<li class="selectable-style" id="${allYears[i]}">` + allYears[i] + '</li>');
        $(`#${allYears[i]}`).on("click", this.yearClicked.bind(this));
    }
    //output just the years
    }

    closeYearElements(){
        if (yearOpen != 0){
            $(`#${yearOpen}`).children().empty();
            $(`#${yearOpen}`).children("ul").remove();
            yearOpen=0;
        }
    }
    openYearElements(){

        $(`#${yearClicked}`).append('<ul></ul>');
        for (var i=0; i<fileList.length; i++){
            if (fileList[i].substring(0,4)==yearClicked){
                $(`#${yearClicked}`).children("ul").append('<li>' + this.getFileText(fileList[i]) + '</li>');
            }
        }
        yearOpen = yearClicked;

    }
    getFileText(filename){
        var text = `<a href="${uploadsLocation + filename}" target="_blank">`;
        if (filename.includes("Committee")){
            text += "Committee Meeting";
        } else if (filename.includes("AGM")){
            text += "AGM";
        }
        switch (filename.substring(5, 7)){
            case "01":
                text += " January";
                break;
            case "02":
                text += " February";
                break;
            case "03":
                text += " March";
                break;
            case "04":
                text += " April";
                break;
            case "05":
                text += " May";
                break;
            case "06":
                text += " June";
                break;
            case "07":
                text += " July";
                break;
            case "08":
                text += " August";
                break;
            case "09":
                text += " September";
                break;
            case "10":
                text += " October";
                break;
            case "11":
                text += " November";
                break;
            case "12":
                text += " December";
                break;
        }
        if (filename.substring(8,9) == '0'){
            text+= " " + filename.substring(9,10);
        } else {
            text+= " " + filename.substring(8,10);
        }
        if (filename.substring(8,10) == '11' ||
            filename.substring(8,10) == '12' ||
            filename.substring(8,10) == '13'){
            text+='th';
        } else if (filename.substring(9,10) == '1'){
            text+='st';
        } else if (filename.substring(9,10) == '2'){
            text+='nd';
        } else if (filename.substring(9,10) == '3'){
            text+='rd';
        } else {
            text+='th';
        }
        text+="</a>";
        return text;
    }
}

export default Minutes;